module.exports = __webpack_public_path__ + "static/media/iconQuestionMark2.b5a94771.svg";